// extracted by mini-css-extract-plugin
export default {"contactsPage":"Contacts_contactsPage__JYJ90","contactsSection":"Contacts_contactsSection__CV5VO","title":"Contacts_title__ubCNB"};